module.exports = __webpack_public_path__ + "static/5-c8b6027f65927eaabc176e6904c598ae.jpg";